/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SuggestCustomDetectionRuleRequestBody,
  SuggestCustomDetectionRuleRequestBody$Outbound,
  SuggestCustomDetectionRuleRequestBody$outboundSchema,
} from "../components/suggestcustomdetectionrulerequestbody.js";

export type SuggestCustomDetectionRuleSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type SuggestCustomDetectionRuleSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type SuggestCustomDetectionRuleSecurity = {
  option1?: SuggestCustomDetectionRuleSecurityOption1 | undefined;
  option2?: SuggestCustomDetectionRuleSecurityOption2 | undefined;
};

export type SuggestCustomDetectionRuleRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  suggestCustomDetectionRuleRequestBody: SuggestCustomDetectionRuleRequestBody;
};

/** @internal */
export type SuggestCustomDetectionRuleSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const SuggestCustomDetectionRuleSecurityOption1$outboundSchema:
  z.ZodMiniType<
    SuggestCustomDetectionRuleSecurityOption1$Outbound,
    SuggestCustomDetectionRuleSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function suggestCustomDetectionRuleSecurityOption1ToJSON(
  suggestCustomDetectionRuleSecurityOption1:
    SuggestCustomDetectionRuleSecurityOption1,
): string {
  return JSON.stringify(
    SuggestCustomDetectionRuleSecurityOption1$outboundSchema.parse(
      suggestCustomDetectionRuleSecurityOption1,
    ),
  );
}

/** @internal */
export type SuggestCustomDetectionRuleSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const SuggestCustomDetectionRuleSecurityOption2$outboundSchema:
  z.ZodMiniType<
    SuggestCustomDetectionRuleSecurityOption2$Outbound,
    SuggestCustomDetectionRuleSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function suggestCustomDetectionRuleSecurityOption2ToJSON(
  suggestCustomDetectionRuleSecurityOption2:
    SuggestCustomDetectionRuleSecurityOption2,
): string {
  return JSON.stringify(
    SuggestCustomDetectionRuleSecurityOption2$outboundSchema.parse(
      suggestCustomDetectionRuleSecurityOption2,
    ),
  );
}

/** @internal */
export type SuggestCustomDetectionRuleSecurity$Outbound = {
  Option1?: SuggestCustomDetectionRuleSecurityOption1$Outbound | undefined;
  Option2?: SuggestCustomDetectionRuleSecurityOption2$Outbound | undefined;
};

/** @internal */
export const SuggestCustomDetectionRuleSecurity$outboundSchema: z.ZodMiniType<
  SuggestCustomDetectionRuleSecurity$Outbound,
  SuggestCustomDetectionRuleSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => SuggestCustomDetectionRuleSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => SuggestCustomDetectionRuleSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function suggestCustomDetectionRuleSecurityToJSON(
  suggestCustomDetectionRuleSecurity: SuggestCustomDetectionRuleSecurity,
): string {
  return JSON.stringify(
    SuggestCustomDetectionRuleSecurity$outboundSchema.parse(
      suggestCustomDetectionRuleSecurity,
    ),
  );
}

/** @internal */
export type SuggestCustomDetectionRuleRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  SuggestCustomDetectionRuleRequestBody:
    SuggestCustomDetectionRuleRequestBody$Outbound;
};

/** @internal */
export const SuggestCustomDetectionRuleRequest$outboundSchema: z.ZodMiniType<
  SuggestCustomDetectionRuleRequest$Outbound,
  SuggestCustomDetectionRuleRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    suggestCustomDetectionRuleRequestBody:
      SuggestCustomDetectionRuleRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      suggestCustomDetectionRuleRequestBody:
        "SuggestCustomDetectionRuleRequestBody",
    });
  }),
);

export function suggestCustomDetectionRuleRequestToJSON(
  suggestCustomDetectionRuleRequest: SuggestCustomDetectionRuleRequest,
): string {
  return JSON.stringify(
    SuggestCustomDetectionRuleRequest$outboundSchema.parse(
      suggestCustomDetectionRuleRequest,
    ),
  );
}
